var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 9.375C14.4492 9.375 13.1876 10.6366 13.1876 12.1875C13.1876 12.6087 13.2872 13.0048 13.4538 13.3638C7.21573 14.5118 2.35167 19.9141 1.92261 26.375H30.0776C29.6485 19.9141 24.7845 14.5118 18.5464 13.3638C18.713 13.0048 18.8126 12.6087 18.8126 12.1875C18.8126 10.6366 17.551 9.375 16.0001 9.375Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 1.875H30.0625V0H21.625C20.0741 0 18.8125 1.26163 18.8125 2.8125C18.8125 4.36337 20.0741 5.625 21.625 5.625H25.375C25.8923 5.625 26.3125 6.04525 26.3125 6.5625C26.3125 7.07975 25.8923 7.5 25.375 7.5H23.5C21.9491 7.5 20.6875 8.76163 20.6875 10.3125V11.25H22.5625V10.3125C22.5625 9.79525 22.9827 9.375 23.5 9.375H25.375C26.9259 9.375 28.1875 8.11337 28.1875 6.5625C28.1875 5.01163 26.9259 3.75 25.375 3.75H21.625C21.1077 3.75 20.6875 3.32975 20.6875 2.8125C20.6875 2.29525 21.1077 1.875 21.625 1.875Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.125H3.1705L4.108 32H27.892L28.8295 30.125H32V28.25H0V30.125Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.58f64b8d586e748873719be3a71012ea.svg";
export { ForwardRef as ReactComponent };